import React, { Component } from "react";
import { Container, Row, Col, Card, CardImg, CardBody } from "reactstrap";
import { isIE, withOrientationChange } from "react-device-detect";
import _ from 'lodash';
import screenFull from 'screenfull';
import toastr from "COMPONENTS/ShowTostr/ShowTostr";
import { toast } from "react-toastify";

import WhiteboardContainer from "COMPONENTS/Whiteboard/WhiteboardContainer";
import AudioVideoContainer from "COMPONENTS/Video/AudioVideoContainer";
import ScreenShareContainer from "COMPONENTS/ScreenShare/ScreenShareContainer";
import CustomerCoBrowseContainer from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseContainer"
import CustomerCoBrowseContainerV2 from "COMPONENTS/CustomerCoBrowseV2/CustomerCoBrowseContainerV2"
import InboundCoBrowseContainer from "@/Components/InboundCoBrowse/InboundCoBrowseContainer"
import ContractInfoModal from "@/Components/ContractInfoModal";

import Spinner from "COMPONENTS/Spinner/Spinner";

import TotalBitRate from "../CommonComponents/BitRate/TotalBitRate";
import FullScreenContainer from "COMPONENTS/FullScreen/FullScreenContainer";
import FullScreenTargetComponent from "COMPONENTS/FullScreen/FullScreenTargetComponent";
import DashboardMenu from "COMPONENTS/DashboardMenu/DashboardMenu"
import CanvasList from "COMPONENTS/Whiteboard/CanvasList/CanvasList";
import MeetingTime from "../CommonComponents/MeetingTime/MeetingTime";
import WaitingArea from "COMPONENTS/WaitingArea/WaitingArea";
import { VirtualBackgroundFilter } from "COMPONENTS/CommonComponents/VirtualBackground/VirtualBackground";

import { audioVideoAction, headerAction } from "CONFIG/ActionFactory";
import {
  COMPONENT_IN_FOCUS, CANVAS_TYPES, USER_ADMISSION_STATUS, PARTICIPANT_STATUS,
  cobrowseTypes, TOAST_ID, USER_ROLES, Modules, FILTER_CONFIG, SESSION_SUBTYPES
} from "UTILS/Constants";
import {
  isMobile, canvasToBlob, isWebRTCPluginInstalled, isLandscapeLayout, isAndroidPhone,
  isTabletPortrait, isDesktopView, isMobileView, isFocusCanvas, isTabletLandscape
} from "UTILS/Utility";

import { mediaType } from "WEBSOCKET/constants";
import { socketMessage } from 'WEBSOCKET/constants';

// Strings
import { getMessage } from "CONFIG/i18n";

import "./Dashboard.less";
import "../Whiteboard/Whiteboard";
import "../Whiteboard/CanvasList/CanvasList";
import "../DashboardMenu/DashboardMenu.less"
import IconsPositionBar from "../Video/IconsPositionBar";
import MobileControlBar from "../MobileControlBar/MobileControlBar";

// Assets
import audio_off from "ASSETS/Images/video_menu/ic_audio_off_small.svg";
import audio_on from "ASSETS/Images/video_menu/ic_audio_on_small.svg";
import video_on from "ASSETS/Images/video_menu/ic_video_on_small.svg";
import video_off from "ASSETS/Images/video_menu/ic_video_off_small.svg";
import sound from "ASSETS/swiftly-610.mp3";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinnerVisibilityCanvasList: false,
      spinnerVisibility: false,
      participant: null,
      pluginInstalled: isIE ? false : true,
      sound: new Audio(sound),
      horizontalDisplayFixed: this.props.horizontalDisplayFixedSettings ? this.props.horizontalDisplayFixedSettings.isEnable || false : false,
      fullScreenV2MainTarget: null,
      fullScreenV2SubTargets: [],
      showWaitingArea: true,
      sortedParticipants: [],
      sessionLink: [],
      makePresenterPopoverOpen: false,
      presenterName: '',
      isHideBar: false,
      isZoomOut: false,
      screen: null,
      isScreenShare: false,
      currentSlide: 0,
      indicatorRange: 7,
      showDeleteConfirmationModal: false,
      canvasIdNumber: '',
      canvasType: '',
      canvases: {},
      isAudioVideoStart: false
    };
    
    this.sliderRef = React.createRef();
    this.canvasRef = React.createRef();
    this.isThumbnailBeingUploaded = false;
    this.stickyScrollInterval = null;
    this.fullScreenChangeHandler = this.fullScreenChangeHandler.bind(this);
    this.needRemoveFullScreenChangeHandler = false;
    this.toggleScreenZoomIn = this.toggleScreenZoomIn.bind(this);
    this.toggleScreenZoomOut = this.toggleScreenZoomOut.bind(this);
    this.putFullScreenV2Target = this.putFullScreenV2Target.bind(this);
    /* About fullScreenV2OnDevTools. 
       Set to true when running full screen V2 in an environment other than smartphones such as DevTools.*/
    this.fullScreenV2OnDevTools = false;
    this.currentStream = null;
    this.currentAudioStream = null;
    this.virtualBackgroundFilter = null;
  }

  componentDidMount() {
    //play sound on mute to cache the sound 
    this.state.sound.volume = 0.0;
    this.playUserArrivalSound();
    if (isIE) {
      this.setAnnotationBarToBottom();

      window.addEventListener('resize', this.setTimeOutAnnotationBarToBottom);
    }
    this.setScreenShareTopMargin();
    window.addEventListener("resize",this.setScreenShareTopMargin());

    this.getBaseUrl();
    if (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS && isMobileView(this.props.orientation)) {
      this.setState({ isHideBar: true });
    }
  }

  setTimeOutAnnotationBarToBottom(){
    clearTimeout(this.stickyScrollInterval);
    this.stickyScrollInterval = setTimeout(() => {
      this.setAnnotationBarToBottom();
    }, 300);
  }

  renderCanvasList = (isCanvasMain) => {
    return (
      // Canvas List cards start)
      <CanvasList
        canvases={this.state.canvases}
        changeActiveCanvas={(canvasId, canvasType, uploadThumbnailFlag, callback) => {
          // this.removeSpotLight();
          // this.removePdfHighLight();
          setTimeout(() => {
            this.changeActiveCanvas(canvasId, canvasType, uploadThumbnailFlag, callback);
          }, 0);
        }}
        deleteCanvas={this.props.deleteCanvas}
        activeCanvas={this.props.canvasId}
        activeCanvasFileUrl={this.props.activeCanvasData.fileUrl}
        onCanvasSwitched={this.onCanvasSwitched}
        enableControls={
          this.props.organiser === this.props.uniqueId
          && !this.props.snapshoteeId
          && !this.props.showCustomerCoBrowse
          && !this.props.showInboundCoBrowse
        }
        enableCloseIcon={
          this.props.organiser === this.props.uniqueId
        }
        showCanvasListSpinner={this.showSpinnerForCanvasList}
        showSpinner={this.showSpinner}
        hideCanvasListSpinner={this.hideSpinnerForCanvasList}
        setIsCanvasModified={this.props.setIsCanvasModified}
        showDeleteConfirmationModal={this.state.showDeleteConfirmationModal}
        canvasIdNumber={this.state.canvasIdNumber}
        canvasType={this.state.canvasType}
        setValue={this.setValue}
        canvasRef={this.canvasRef}
        componentInFocus={this.props.componentInFocus}
        setComponentInFocus={this.props.setComponentInFocus}
        isAutoSaveSnapShot={this.props.isAutoSaveSnapShot}
        isCanvasMain={isCanvasMain}
        isZoomOut={this.state.isZoomOut}
        screenSharingParticipantId={this.props.screenSharingParticipantId}
        orientation={this.props.orientation}
        getValidActiveCanvasId={this.getValidActiveCanvasId}
        modules={this.props.modules}
      //closePopover={this.closePopover}
      />
    );
  }

setAnnotationBarToBottom = () => {
  const annotationBar = document.getElementById('annotationBar')
  const scrollY = document.getElementById('scrollY');

  if (!annotationBar || !scrollY) return;
  const annotationBarBound = annotationBar.getBoundingClientRect();

  var setAnnotationStyles = () => {
    let callControls = document.getElementById("iconsPosition" + this.props.uniqueId);
    let canvasSizer = document.getElementById("canvasSizer");
    if ((window.pageYOffset + window.innerHeight) < annotationBarBound.bottom
      && !this.props.showSnapshot) {
      if (canvasSizer) {
        annotationBar.style.width = canvasSizer.offsetWidth + 'px';
      }
      scrollY.style.marginTop = annotationBar.offsetHeight + 'px';
      annotationBar.style.position = 'fixed';
      annotationBar.style.bottom = 0;
      if (!callControls) return;
      // callControls.parentElement.style.position = 'fixed';
      // callControls.parentElement.style.bottom = 0;
      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS)
        this.setIconPosition();
    } else {
      annotationBar.style.position = 'static';
      annotationBar.style.width = '100%';
      annotationBar.style.bottom = '';
      scrollY.style.marginTop = "0px"
      if (!callControls) return;
      // callControls.parentElement.style.position = 'fixed';
      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS)
        this.setIconPosition();
    }
  }
  setAnnotationStyles();
  window.addEventListener('scroll', setAnnotationStyles);
}

setIconPosition = () => {
  // find bounds for self icon bar
  let annotationBar = document.getElementById("annotationBar");
  // let videoComponent = document.getElementById("videoComponent");

  let iconBar = document.getElementById("iconsPosition" + this.props.uniqueId);

  if (!iconBar) return;

  // when canvas is in focus set position of A/V icons based on annotation bar position 
  if (this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS) {
    iconBar.style.position = "fixed"
  } else {
    iconBar.style.position = "static"
    iconBar.style.top = iconBar.style.top + "px"
  }

  if (!annotationBar) return;
  let annotationBarBound = annotationBar.getBoundingClientRect();
  iconBar.style.left = ((annotationBarBound.left + annotationBarBound.right) / 2) + "px";
  iconBar.style.top = annotationBarBound.top + 10 + "px"
}

playUserArrivalSound = () => {
  let playPromise = this.state.sound.play();
  if (playPromise !== undefined) {
    playPromise.then(_ => {
      // Automatic playback started!
      // Show playing UI.
    })
    .catch(error => {
      // Auto-play was prevented
      // Show paused UI.
    });
  }
}

  fullScreenChangeHandler = () => {
    if(!screenFull.isFullscreen){
      headerAction.setIsFullScreenV2(false);
      this.setState({
        fullScreenV2MainTarget: null
      });
      this.setState({
        fullScreenV2SubTargets: []
      });
      screenFull.off('change', this.fullScreenChangeHandler);
      this.needRemoveFullScreenChangeHandler = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
  /*
  * ring bell when 
  * 1) Agent started session, new participant request to join the session.
  * 2) User waiting to join session before start session and agent start session. 
  * 3) Agent started session, user on waiting screen, agent refresh the screen. 
  * 4) Agent started session, user join session, user on waiting screen, user refresh the screen.
  * 5) Agent started session, agent tab on background user join the session. 
  */
    if (this.props.latestUpdatedParticipant !== prevProps.latestUpdatedParticipant &&
    this.props.latestUpdatedParticipant &&
    this.props.latestUpdatedParticipant.admissionStatus === USER_ADMISSION_STATUS.PENDING &&
    this.props.latestUpdatedParticipant.status !== PARTICIPANT_STATUS.LEFT) {
      this.state.sound.volume = 1;
      this.state.sound.load();
      this.playUserArrivalSound();
    }

    if (screenFull.isEnabled) {
      if (this.props.isFullScreenV2 && !prevProps.isFullScreenV2 ) {
        screenFull.on('change', this.fullScreenChangeHandler );
        this.needRemoveFullScreenChangeHandler = true;
      }
    }

    if (this.props.showAudioVideoComponent !== prevProps.showAudioVideoComponent
    || this.props.showCoBrowse !== prevProps.showCoBrowse) {
      this.selectParticipantObjectForSelf();
      // need to reset screenshare top when audio video component is opened / closed
      this.setScreenShareTopMargin();
    }
    if (!_.isEqual(this.props.admittedParticipants, prevProps.admittedParticipants)) {
      this.selectParticipantObjectForSelf();
    }
    if (this.props.showCoBrowse && this.props.isLandscape !== prevProps.isLandscape) {
      this.changeFocusOnOrientationChange();
    }
    if (this.props.showCoBrowse && this.props.showCoBrowse !== prevProps.showCoBrowse && isMobileView(this.props.orientation)) {
    }
    if (this.props.screenSharingParticipantId !== prevProps.screenSharingParticipantId
    || this.props.componentInFocus !== prevProps.componentInFocus
    || this.props.sortedParticipants !== prevProps.sortedParticipants
    || this.props.isLandscape !== prevProps.isLandscape
    || (isMobileView(this.props.orientation)
      && this.props.activeCanvasData.canvasType !== prevProps.activeCanvasData.canvasType)) {
    // need to reset screenshare top when component in focus changes 
    // || participant is added or removed which causes audtio video container height change 
    // || screenshare is started 
      this.setScreenShareTopMargin();
    }
    if (isIE) {
      if (this.props.showAudioVideoComponent !== prevProps.showAudioVideoComponent) {
        let annotationBarEle = document.getElementById('annotationBar');
        let canvasSizer = document.getElementById("canvasSizer");

        if (annotationBarEle && canvasSizer && this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO) {
          annotationBarEle.style.left = canvasSizer.getBoundingClientRect().left + 'px';
        }
        this.setIconPosition();
      }

      if (this.props.componentInFocus !== prevProps.componentInFocus
        || (this.props.showSnapshot !== prevProps.showSnapshot && this.props.showSnapshot)) {
        if (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS) {
          const annotationBar = document.getElementById("annotationBar");

          // reset styles applied
          annotationBar.style.position = 'static';
          annotationBar.style.left = '';
          annotationBar.style.top = '';
          annotationBar.style.bottom = '';

          const iconBar = document.getElementById("iconsPosition" + this.props.uniqueId);

          // reset styles applied
          if (iconBar) {
            iconBar.style.position = 'static';
            iconBar.style.left = '';
            iconBar.style.top = '';
            iconBar.style.width = '';
          }

          this.setAnnotationBarToBottom();
        }
      }
  
    }

    // for self - check and show toast msg and send plugin status only for screenshare
    // for rest of the webrtc features, the plugin status is sent in respective permission reply
    if (this.props.screenSharingParticipantId !== prevProps.screenSharingParticipantId
  && this.props.screenSharingParticipantId) {
  
      if (isIE) {
        let isPluginInstalled = isWebRTCPluginInstalled();
        this.setState({
          pluginInstalled: isPluginInstalled
        });
        if (!isPluginInstalled) {
          this.props.sendPluginNotInstalled();
        }
      } else {
        // For modern browsers, assume WebRTC is supported
        this.setState({
          pluginInstalled: true
        });
      }
    }

    if (prevProps.presenter !== this.props.presenter) {
      this.sortParticipantToAcronym();
    }

    if (!_.isEqual(this.props.allParticipants, prevProps.allParticipants)) {
      this.sortParticipantToAcronym();
    }

    if (isMobileView(this.props.orientation) && this.props.componentInFocus !== prevProps.componentInFocus) {
      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS || this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE) {
        this.setState({ isHideBar: true });
      }else {
        this.setState({ isHideBar: false });
      }
    }

    if (prevProps.canvases !== this.props.canvases) {
      const newCanvases = this.props.modules.indexOf(Modules.CANVAS) == -1
        ? Object.fromEntries(Object.entries(this.props.canvases).filter(([key,_]) => key !== "1"))
        : this.props.canvases;
      this.setState({ canvases: newCanvases });
    }

    if (this.props.modules.indexOf(Modules.CANVAS) == -1) {
      const isSnapshotData = Object.values(this.state.canvases).findIndex(item => { return item.canvasType === "IMAGE"; });
      if(prevProps.showSnapshot !== this.props.showSnapshot){
        if(!this.props.showSnapshot && isSnapshotData == -1){
          this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO); 
        }
      }

      if(prevProps.isSnapShotSave !== this.props.isSnapShotSave){
        if (this.props.isSnapShotSave === false && isSnapshotData == -1) {
          this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
          headerAction.setIsSnapshotSave(null);
        } else if (this.props.isSnapShotSave) {
          this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
          if(!this.props.isAutoSaveSnapShot){
            headerAction.setIsSnapshotSave(null);
          }
        }
      }
    }

    if(
      prevProps.isSnapShotUploading !== this.props.isSnapShotUploading
      && this.props.isSnapShotUploading
    ) {
      if (
        isDesktopView(this.props.orientation)
        || (isMobileView(this.props.orientation) && this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS)
      ) {
        this.showSpinner();
      }
      headerAction.setIsSnapShotUploading(false);
    }
  }

  getValidActiveCanvasId = () => {
    let idList = [];
    Object.keys(this.state.canvases).map((key) => {
      return idList.push(Number(key));
    });

    let activeCanvasIndex = idList.findIndex((id)=>{
      return id === this.props.canvasId;
    })
    
    activeCanvasIndex = activeCanvasIndex == -1 ? 0 : activeCanvasIndex;

    return activeCanvasIndex + 1;
  }

  waitForOffsetWidth(func) {
    const intervalId = setInterval(() => {
      if (this.sliderRef.current.offsetWidth > 0 || this.sliderRef.current.clientWidth > 0) {
        clearInterval(intervalId);
        func();
      }
    }, 100);
  }
  
  uploadThumbnail = (blob, callback) => {
    console.log("in uploadThumbnail....................");

    let thumbnailBlob = blob;
    let backdropPresent = null;
    if (this.props.activeCanvasRef) {
      backdropPresent = this.props.activeCanvasRef._objects.filter(obj =>
        obj.objectType == 'backgroundImage')[0];
    }
    if (backdropPresent)
      return;

    if (this.props.uniqueId === this.props.organiser
      || this.props.uniqueId === this.props.presenterId) {
      if (this.props.activeCanvasRef || this.props.activeCanvasData.canvasType === CANVAS_TYPES.PDF) {
        if (!thumbnailBlob) {
          thumbnailBlob = canvasToBlob(this.props.activeCanvasRef, '#FFFFFF');
        }
        this.isThumbnailBeingUploaded = true;
        this.props.uploadCanvasThumbnail(this.props.activeCanvasData, thumbnailBlob, (error) => {
          this.isThumbnailBeingUploaded = false;
          console.log("thumbnail is uploaded");
          if (error) {
            this.hideSpinnerForCanvasList();
          }
        })
      }
    } else {
      // when agent uploads a pdf then presenter uploads another
      // agent switches between canvases, spinner is displayed for the pdf uploaded by agent at presenter's end 
      // because the ownerOfLastAction was agent (canvas list spinner will never hide)
      this.hideSpinnerForCanvasList();
    }
    if (callback) callback();
  }

  shouldShiftWhiteboardToLeft = () => {
    //If audio / video or screenshare is running then shift whiteboard to left
    const isSupportCenter = this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER;
    // サポートセンター会議の場合は、webRtcPermissionRequestと、webRtcPermissionReplyを判定する
    // サポートセンター会議以外の場合は判定しない
    if (
      (isSupportCenter && this.props.webRtcPermissionRequest && 
        (this.props.webRtcPermissionReply === true || this.props.showAudioVideoComponent)) ||
      (!isSupportCenter && this.props.showAudioVideoComponent) ||
        this.props.screenSharingParticipantId !== null || this.props.showCoBrowse || 
        (this.props.showInboundCoBrowse || (!this.props.isInboundCobrowseMinimize && !this.props.endInboundCoBrowse))
    ) {
      return true;
    }
    return false;
  };

  onCanvasSwitched = (switchedCanvasType) => {
    this.setSwitchedCanvasType(switchedCanvasType);
  }

  setSwitchedCanvasType = (switchedCanvasType) => {
    this.setState({
      switchedCanvasType: switchedCanvasType
    })
  }

  showSpinnerForCanvasList = () => {
    // added organiser and presenter checks for spinnerVisibilityCanvasList because
    // this spinner should only be visible in case of thumbnail upload and that can only be done 
    // by organiser or presenter 
    if (!isMobile() && !isTabletPortrait(this.props.orientation)
      && (this.props.uniqueId === this.props.organiser
        || this.props.uniqueId === this.props.presenterId)
      && !this.state.spinnerVisibilityCanvasList) {
      console.log("showing canvaslist spinner:");
      this.setState({
        spinnerVisibilityCanvasList: true
      });
    }
    //setTimeout(this.hideSpinnerForCanvasList(), TIMEOUT.SPINNER_TIMEOUT);
  };

  hideSpinnerForCanvasList = () => {
    console.log("hidding canvaslist spinner", this.isThumbnailBeingUploaded);
    !this.isThumbnailBeingUploaded && this.setState({
      spinnerVisibilityCanvasList: false
    });
  };

  showSpinner = () => {
    !this.state.spinnerVisibility && this.setState({
      spinnerVisibility: true
    });
    //setTimeout(this.hideSpinner(), TIMEOUT.SPINNER_TIMEOUT);
  };

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    });
  };

  changeActiveCanvas = (canvasId, canvasType, uploadThumbnailFlag = true, callback) => {
    console.log("in dashboard.changeActiveCanvas");
    this.isThumbnailBeingUploaded = true;
    this.props.changeActiveCanvas(canvasId, canvasType, uploadThumbnailFlag, () => {
      console.log("in dashboard.changeActiveCanvas callback");
      this.isThumbnailBeingUploaded = false;
      callback && callback();
    });
  }

  selectParticipantObjectForSelf = () => {
    _.map(this.props.admittedParticipants, participantObject => {
      if (participantObject.uniqueId === this.props.uniqueId) {
        //let participant = _.cloneDeep(participantObject);
        this.setState({ participant: participantObject })
      }
    })
  }

  setEndCall = (value) => {
    this.setState({
      endCall: value
    })
  }

  changeFocusOnOrientationChange = () => {
    if (this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply)) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    } else if (!(this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply))) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.COBROWSE);
    }
  }

  setScreenShareTopMargin = () => {
    let screenshareContainer = document.getElementById("screenshareContainer");
    if (!screenshareContainer) return;

    let whiteboard = document.getElementById("whiteboard");
    let whiteboardHeight = whiteboard ? whiteboard.offsetHeight : 0;
    let audioVideoContainer = document.getElementById("videoComponent2");
    let audioVideoContainerHeight = audioVideoContainer ? audioVideoContainer.offsetHeight : 0;
    let header = document.getElementsByClassName("headerLogoContainer")[0];
    let headerHeight = header ? header.offsetHeight : 0;
    if (window.innerWidth < 767) {
      if (!this.props.isLandscape && this.props.activeCanvasData.canvasType === CANVAS_TYPES.PDF) {
        // because on mobile device screen share position is relative 
        if (isLandscapeLayout(this.props.isLandscape)) {
          screenshareContainer.style.top = audioVideoContainerHeight + "px";
        } else {
          screenshareContainer.style.top = "0px";
        }
      }
      return;
    }
    if (this.props.showAudioVideoComponent || this.props.showCoBrowse) {
      let audioVideoHeight = 0;
      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO) {
        audioVideoHeight = audioVideoContainerHeight * 2;
      } else {
        audioVideoHeight = audioVideoContainerHeight * 3;
      }

      if (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
        || (isLandscapeLayout(this.props.isLandscape) && this.props.componentInFocus == COMPONENT_IN_FOCUS.COBROWSE)) {
        //screenshareContainer.style.top = `calc(${whiteboardHeight + audioVideoHeight}px)`;
      } else {
        //screenshareContainer.style.top = `calc(${audioVideoHeight}px)`;
      }
      return;
    }
  }

  toggleScreenZoomOut = () => {
    if ( !this.fullScreenV2OnDevTools ) {
      screen.orientation.unlock();
    }
    this.state.fullScreenV2MainTarget.setFullScreenV2Target(false);
    this.setState({
      fullScreenV2MainTarget: null
    });

    this.state.fullScreenV2SubTargets.map((target,index) => {
      target.setFullScreenV2Target(false);
    });

    this.setState({
      fullScreenV2SubTargets: []
    });
    headerAction.setIsFullScreenV2(false);
    screenFull.exit();
  }

  isOrientationLockSupported = async () => {
    const support = await screen.orientation.lock("landscape")
    .then(() => {
      screen.orientation.unlock();
      return true;
    })
    .catch((error) => {
      if (error.name == "NotSupportedError") {
        return false;
      } else if( error.name == "SecurityError"){
        return true;
      } else {
        throw new Error('internal error');
      }
    });
    return support;
  }

  toggleScreenZoomIn = async (mainTarget) => {
    const instanceCheck =  mainTarget instanceof FullScreenTargetComponent;
    if ( !instanceCheck ) {
      throw new Error('Classes that do not support full-screen display.');
    }
    if ( !this.fullScreenV2OnDevTools ) {
      const rc = await this.isOrientationLockSupported();
      if( !rc ) return false;
    } else {
      if(!this.props.isLandscape) return false;
    }

    const fullScreenDiv = document.getElementById("fullScreenV2Container");
    mainTarget.setFullScreenV2Target(true);
    this.setState({
      fullScreenV2MainTarget: mainTarget
    });
    headerAction.setIsFullScreenV2(true);
    screenFull.request(fullScreenDiv, {navigationUI: 'hide'});
    if ( !this.fullScreenV2OnDevTools ) {
      screen.orientation.lock("landscape")
      .then(() => {
        console.log(`toggleScreenZoomIn() screen.orientation.lock OK`);
      })
      .catch((error) => {
        console.log(`toggleScreenZoomIn() screen.orientation.lock NG ${error}`);
      });
    }

    return true;
  }

  putFullScreenV2Target = (target) => {
    const instanceCheck =  target instanceof FullScreenTargetComponent;
    if ( !instanceCheck ) {
      throw new Error('Classes that do not support full-screen display.');
    }
    target.setFullScreenV2Target(true);
    const currentSubTargets = this.state.fullScreenV2SubTargets;
    const newSubTargets = [...currentSubTargets, target];
    this.setState({
      fullScreenV2SubTargets: newSubTargets
    });
  }
  removeFullScreenV2Target = (target) => {
    const instanceCheck =  target instanceof FullScreenTargetComponent;
    if ( !instanceCheck ) {
      throw new Error('Classes that do not support full-screen display.');
    }
    const currentSubTargets = this.state.fullScreenV2SubTargets;
    const targetIdx = currentSubTargets.indexOf(target);
    if ( -1 != targetIdx ) {
      currentSubTargets[targetIdx].setFullScreenV2Target(false);
      currentSubTargets.splice( targetIdx, 1);
      const newSubTargets = [...currentSubTargets];
      this.setState({
        fullScreenV2SubTargets: newSubTargets
      });
    } else if (this.state.fullScreenV2MainTarget === target ) {
      if ( currentSubTargets.length == 0 ) {
        this.toggleScreenZoomOut();
      } else {
        const newMainTarget = currentSubTargets[0];
        currentSubTargets.splice( 0, 1);
        const newSubTargets = [...currentSubTargets];
        this.setState({
          fullScreenV2MainTarget: newMainTarget
        });
        this.setState({
          fullScreenV2SubTargets: newSubTargets
        });
      }
    } else if ( currentSubTargets.length == 0 && this.props.isFullScreenV2 ) {
      this.toggleScreenZoomOut();
    }
  }

  switchFullScreenV2MainTarget = (newMainTarget) => {
    const instanceCheck =  newMainTarget instanceof FullScreenTargetComponent;
    if ( !instanceCheck ) {
      throw new Error('Classes that do not support full-screen display.');
    }
    const targetIdx = this.state.fullScreenV2SubTargets.indexOf(newMainTarget);
    if (-1 != targetIdx ) {
      const currentMainTarget = this.state.fullScreenV2MainTarget;
      const currentSubTargets = this.state.fullScreenV2SubTargets;
      currentSubTargets.splice( targetIdx, 1);
      const newSubTargets = [...currentSubTargets, currentMainTarget];
      this.setState({
        fullScreenV2MainTarget: newMainTarget
      });
      this.setState({
        fullScreenV2SubTargets: newSubTargets
      });
    }
  }

  toggleHideBar = (hideBar) => {
    const _hideBar = this.state.isHideBar
    this.setState({
      isHideBar : hideBar !== undefined ? hideBar : !_hideBar
    })
    console.log(_hideBar, this.state.isHideBar)
  }

  setCurrentStream = (stream) => {
    console.info(`setCurrentStream() stream.id=${stream && stream.id !== undefined ? stream.id : ''}  createTime(keyword)`);
    this.currentStream = stream;
  }

  setCurrentAudioStream = (stream) => {
    console.info(`setAudioCurrentStream() stream.id=${stream && stream.id !== undefined ? stream.id : ''}  createTime(keyword)`);
    this.currentAudioStream = stream;
  }

  setCurrentVirtualBackgroundFilter = (filter) => {
    this.virtualBackgroundFilter = filter;
  }
  getCurrentVirtualBackgroundFilter = () => {
    if ( !this.virtualBackgroundFilter ) {
      const filter = new VirtualBackgroundFilter(FILTER_CONFIG[this.props.selectedBackground]);
      this.virtualBackgroundFilter = filter;
    } else {
      this.virtualBackgroundFilter.setBackground(FILTER_CONFIG[this.props.selectedBackground]);
    }
    return this.virtualBackgroundFilter;
  }

  stopTracks = (localStream) => {
    this.virtualBackgroundFilter && this.virtualBackgroundFilter.stop();
    console.log(`stopTracks() call this.setCurrentStream(null) createTime=${this.createTime}`);
    this.setCurrentStream(null)
    if (localStream) {
      localStream.getTracks().forEach(track => track.stop());
      const videoTracks = localStream.getVideoTracks();
      for (let i = 0; i !== videoTracks.length; ++i) {
        videoTracks[i].stop();
      }
      let videoElement = document.getElementById(this.props.uniqueId + "video");
      if(videoElement){
        videoElement.srcObject = null;
      }
    }
  }
  stopAudioTracks = (localStream) => {
    this.currentAudioStream = null;
    if (localStream) {
      localStream.getTracks().forEach(track => track.stop());
      const audioTracks = localStream.getAudioTracks();
      for (let i = 0; i !== audioTracks.length; ++i) {
        audioTracks[i].stop();
      }
    }
  }

  renderWhiteboardContainer = () => {
    return <WhiteboardContainer
      endCall={this.state.endCall}
      broadcastDownloadAction={this.props.broadcastDownloadAction}
      shouldShiftWhiteboardToLeft={this.shouldShiftWhiteboardToLeft}
      componentInFocus={this.props.componentInFocus}
      addCanvas={this.props.addCanvas}
      uploadFile={this.props.uploadFile}
      uploadThumbnailForGuest={this.props.uploadThumbnailForGuest}
      uploadThumbnail={this.uploadThumbnail}
      uploadCanvasThumbnail={this.props.uploadCanvasThumbnail}
      showSpinnerForCanvasList={this.showSpinnerForCanvasList}
      hideSpinnerForCanvasList={this.hideSpinnerForCanvasList}
      showSpinner={this.showSpinner}
      hideSpinner={this.hideSpinner}
      spinnerVisibility={this.state.spinnerVisibility}
      spinnerVisibilityCanvasList={this.state.spinnerVisibilityCanvasList}
      changeActiveCanvas={this.changeActiveCanvas}
      setComponentInFocus={this.props.setComponentInFocus}
      webRtcPermissionReply={this.props.webRtcPermissionReply}
      setSwitchedCanvasType={this.setSwitchedCanvasType}
      switchedCanvasType={this.state.switchedCanvasType}
      removePdfHighLight={this.removePdfHighLight}
      onFreezeFrame={this.props.onFreezeFrame}
      setIsCanvasModified={this.props.setIsCanvasModified}
      showAudioVideoComponent={this.props.showAudioVideoComponent}
      getPdfListFromCloud={this.props.getPdfListFromCloud}
      getCloudFileUrl={this.props.getCloudFileUrl}
      showCoBrowse={this.props.showCoBrowse}
      isLandscape={this.props.isLandscape}
      isZoomOut={this.state.isZoomOut}
      isScreenShare={this.state.isScreenShare}
      orientation={this.props.orientation}
      screenSharingParticipantId={this.props.screenSharingParticipantId}
      setValue={this.setValue}
      isHideBar={this.state.isHideBar}
      deleteCanvas={this.props.deleteCanvas}
      showDeleteConfirmationModal={this.state.showDeleteConfirmationModal}
      canvasIdNumber={this.state.canvasIdNumber}
      canvasType={this.state.canvasType}
      canvases={this.state.canvases}
    />
  }

  handleAudioVideoStart = () => {
    this.setState({ isAudioVideoStart: true });
  };

  renderAudioVideoContainer = ( isMine, callLimit, isMobileBottomArea = false ) => {
    return <AudioVideoContainer
      webRtcPermissionRequest={
        this.props.webRtcPermissionRequest
      }
      setValue={this.setValue}
      headerAction={headerAction}
      componentInFocus={this.props.componentInFocus}
      setComponentInFocus={this.props.setComponentInFocus}
      setEndCall={this.setEndCall}
      endCall={this.state.endCall}
      setScreenShareTopMargin={this.setScreenShareTopMargin}
      modules={this.props.modules}
      horizontalDisplayFixed={this.state.horizontalDisplayFixed}
      handleFullScreenV2={this.toggleScreenZoomIn}
      putFullScreenV2Target={this.putFullScreenV2Target}
      removeFullScreenV2Target={this.removeFullScreenV2Target}
      isMine={isMine}
      isHideBar={this.state.isHideBar}
      orientation={this.props.orientation}
      screenSharingParticipantId={this.props.screenSharingParticipantId}
      currentStream={this.currentStream}
      currentAudioStream={this.currentAudioStream}
      setCurrentStream={this.setCurrentStream}
      setCurrentAudioStream={this.setCurrentAudioStream}
      stopTracks={this.stopTracks}
      stopAudioTracks={this.stopAudioTracks}
      isShowPreview={callLimit}
      onAudioVideoStart={this.handleAudioVideoStart}
      isAudioVideoStart={this.state.isAudioVideoStart}
      isMobileBottomArea={isMobileBottomArea}
      isAllowRecording={callLimit}
      virtualBackgroundFilter={this.virtualBackgroundFilter}
      setCurrentVirtualBackgroundFilter={this.setCurrentVirtualBackgroundFilter}
      getCurrentVirtualBackgroundFilter={this.getCurrentVirtualBackgroundFilter}
      isScreenShare={this.state.isScreenShare}
      showAudioVideoComponent={this.props.showAudioVideoComponent}
    />
  }

  renderSelfAudioVideoIconBar = () => {
    if (!(isMobile() || isTabletPortrait(this.props.orientation))
      && this.props.showAudioVideoComponent && this.state.participant) {

      return <IconsPositionBar
        isVideo={this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO
          ? true
          : false}
        className={this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS
          ? "floatingAudioVideoControls"
          : "displayFlex justifyContentFlexCenter alignItemsCenter annotationBar"
        }
        parentClassname="annotation"
        iconsDivClassname="iconsBackground"
        sessionKey={this.props.sessionKey}
        organiser={this.props.organiser}
        uniqueId={this.props.uniqueId}
        participant={this.state.participant}
        index={0}
        onOpenCloseEndVideoCallConfirmationModal={() => { this.setEndCall(true) }}
        onOpenCloseEndAudioCallConfirmationModal={() => { this.setEndCall(true) }}
        selfIcons={true}
        audioOn={audio_on}
        audioOff={audio_off}
        videoOn={video_on}
        videoOff={video_off}
      />
    }
  }

  renderMobileBottomArea = () => {
    let sliderItemLength = 0
    const sliderItemArray = new Array()
    const isCanvasShow = this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS || 
    (this.props.componentInFocus === COMPONENT_IN_FOCUS.CANVAS && ((this.props.screenSharingParticipantId !== null && this.state.pluginInstalled) && !this.state.isZoomOut) || this.props.showCustomerCoBrowse)
    const isScreenShareShow = (this.props.screenSharingParticipantId !== null && this.state.pluginInstalled) && this.state.isZoomOut
    const isAudioVideoShow = this.props.showAudioVideoComponent && this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO
    
    if(isCanvasShow){
      sliderItemArray.push("isCanvasShow")
    }
    if(isScreenShareShow){
      sliderItemLength++
      sliderItemArray.push("isScreenShareShow")
    }
    if(isAudioVideoShow){
      sliderItemLength += this.props.sortedParticipants.length
      for(let i = 0; i < this.props.sortedParticipants.length; i++){
        sliderItemArray.push("isAudioVideoShow" + i)
      }
    }
    const isSliderMovable = sliderItemLength > 2

    if(this.sliderRef.current){
      if(!isSliderMovable) {
        this.sliderRef.current.style.transform = `translate(0, 0)`;
      }
    }
    return (
      <>
        <div id="mobileBottomArea" className={`mobileBottomArea${this.state.isHideBar ? " hide" : ""}`}>
          <div className={`mobileBottomAreaWrapper`}>
            <div className="mobileBottomAreaSlider"
              ref={this.sliderRef}
            >
              {
                isCanvasShow && 
                this.renderCanvasList()
              }
              {isScreenShareShow &&
                <div className="mobileBottomAreaItem">
                  {this.renderScreenShareContainer("screenshareMobile")}
                </div>
              }
              {
                this.props.showAudioVideoComponent && 
                <div
                  style={{
                    display: isAudioVideoShow ? "block" : "none" 
                  }}
                >
                  {
                    this.renderAudioVideoContainer(false, this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO, true)
                  }
                </div>
              }
            </div>
            {sliderItemLength > 2 && 
              <>
                {
                  this.renderNavigator(
                    (e) => this.slideMovePrev(e, sliderItemArray),
                    (e) => this.slideMoveNext(e, sliderItemArray)
                  )
                }
                {
                  this.renderIndicator(sliderItemArray)
                }
              </>
            }
          </div>
          {this.renderMobileControlBar()}
        </div>
        <div
          id="mobileBottomAreaToggleBtn"
          className={`mobileBottomAreaToggleBtn${this.state.isHideBar ? " rotated" : ""}`}
          onClick={() => this.toggleHideBar()}
        />
      </>
    )
  }

  renderNavigator = (prevFunc, nextFunc) => {
    return(
      <div className="slider-navigator">
        <svg
          onClick={prevFunc}
          className="arrow arrow--left"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
        <svg
          onClick={nextFunc}
          className="arrow arrow--right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
      </div>
    )
  }

  slideMovePrev = (e, participants) => {
    e.stopPropagation()
    let prevSlideNum = this.state.currentSlide >= 1 ? this.state.currentSlide - 1 : participants.length - 2;
    this.slideMove(-1, prevSlideNum, participants.length - 1)
    this.setState({currentSlide: prevSlideNum});
  }

  slideMoveNext = (e, participants) => {
    e.stopPropagation()
    let nextSlideNum = this.state.currentSlide < participants.length - 2 ? this.state.currentSlide + 1 : 0;
    this.slideMove(1, nextSlideNum, participants.length - 1)
    this.setState({currentSlide: nextSlideNum});
  }
  
  slideMove = (step, afterNum, max) => {
    const moveToWidth = this.sliderRef.current.offsetWidth / 2;
    let afterScrollLeft = moveToWidth * afterNum;
    this.sliderRef.current.style.transition = "transform .3s ease-out";
    if(afterNum >= max && step > 0) {
      this.sliderRef.current.style.transform = `translate(0, 0)`;
    } else if(afterNum >= max && step < 0) {
      this.sliderRef.current.style.transform = `translate(-${moveToWidth * (max - 1)}px, 0)`;
    } else {
      this.sliderRef.current.style.transform = `translate(-${afterScrollLeft}px, 0)`;
    }
  }

  renderIndicator = (participants) => {
    return(
      <div className="indicator">
        {
          participants.length > 7 && (
            <div className={`indicator__arrow indicator__arrow--left${this.state.currentSlide - 3 <= 0 ? " indicator__arrow--disabled" : ""}`}></div>
          )
        }
        {
          participants.map((participant,index) => {
            if(participants.length > this.state.indicatorRange){
              let lowerIndex = this.state.currentSlide - 3;
              let upperIndex = this.state.currentSlide + 4;
              if(lowerIndex <= 0) lowerIndex = 0;
              if(upperIndex > participants.length - 1) lowerIndex = participants.length - this.state.indicatorRange
              if(upperIndex < this.state.indicatorRange) upperIndex = this.state.indicatorRange
              if(index < lowerIndex || index >= upperIndex) return null;
            }
            return (index < participants.length - 1) ? 
              (
                <div key={index + 'indicator'} className={`dot${
                  index === (this.state.currentSlide) ? ' current' : ''}`} />
              ) : null;
          })
        }
        {
          participants.length > 7 && (
            <div className={`indicator__arrow indicator__arrow--right${this.state.currentSlide + 4 > participants.length - 1 ? " indicator__arrow--disabled" : ""}`}></div>
          )
        }
      </div>
    )
  }

  renderMobileControlBar = () => {
    if (this.state.participant) {
      return (
        <MobileControlBar
          isVideo={this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO
            ? true
            : false}
          className="mobileControlBarItem"
          parentClassname="mobileControlBar"
          iconsDivClassname="mobileControlBarWrapper"
          sessionKey={this.props.sessionKey}
          organiser={this.props.organiser}
          uniqueId={this.props.uniqueId}
          participant={this.state.participant}
          index={0}
          onOpenCloseEndVideoCallConfirmationModal={() => { this.setEndCall(true) }}
          onOpenCloseEndAudioCallConfirmationModal={() => { this.setEndCall(true) }}
          selfIcons={true}
          audioOn={audio_on}
          audioOff={audio_off}
          videoOn={video_on}
          videoOff={video_off}
          headerAction={headerAction}
          userRole={this.props.userRole}
          webRtcPermissionRequest={this.props.webRtcPermissionRequest}
          presenter={this.props.presenterId}
          screenSharingParticipantId={this.props.screenSharingParticipantId}
        />
      )
    }
  }

  renderCustomerCoBrowseContainer = () => {
    if (this.props.cobrowseType === cobrowseTypes.CUSTOMER_CO_BROWSE) {
      return (
        <CustomerCoBrowseContainer
          showTargetSiteSelectionModal={this.props.showTargetSiteSelectionModal}
          showCustomerCoBrowse={this.props.showCustomerCoBrowse} 
          setComponentInFocus={this.props.setComponentInFocus}
          endCustomerCBSession={this.props.endCustomerCBSession}
          isHideBar={this.state.isHideBar}
          toggleHideBar={this.toggleHideBar}
        />
      )
    }
    else {
      return (
        <CustomerCoBrowseContainerV2
          showTargetSiteSelectionModal={this.props.showTargetSiteSelectionModal}
          showCustomerCoBrowse={this.props.showCustomerCoBrowse} 
          setComponentInFocus={this.props.setComponentInFocus}
          endCustomerCBSession={this.props.endCustomerCBSession}
          isHideBar={this.state.isHideBar}
          toggleHideBar={this.toggleHideBar}
        />
      )
    }
  }

  renderInboundCoBrowseContainer = () => {
    return (
      <InboundCoBrowseContainer 
        showInboundCoBrowse={this.props.showInboundCoBrowse} 
        setComponentInFocus={this.props.setComponentInFocus}
        isInboundCobrowseMinimize={this.props.isInboundCobrowseMinimize}
        componentInFocus={this.props.componentInFocus}
        setValue={this.setValue}
        isScreenShare={this.state.isScreenShare}
      />
    )
  }

  renderFullScreenContainer = () => {
    return (
      <FullScreenContainer
        toggleScreenZoomOut={this.toggleScreenZoomOut}
        mainTarget={this.state.fullScreenV2MainTarget}
        subTargets={this.state.fullScreenV2SubTargets}
        switchMainTarget={this.switchFullScreenV2MainTarget}
      />
    );
  }

  renderDashboardMenu = () => {
    return (
      <DashboardMenu
        sendWebsocketMessage={this.props.sendWebsocketMessage}
        sessionKey={this.props.sessionKey}
        presenter={this.props.presenterId}
        loggingLevel={this.props.loggingLevel}
        userRole={this.props.userRole}
        modules={this.props.modules}
        uniqueId={this.props.uniqueId}
        organiser={this.props.organiser}
        showWaitingArea={this.state.showWaitingArea}
        handleParticipantsIcon={this.handleParticipantsIcon}
        sessionType={this.props.sessionType}
        operatorExclusiveRecordingControl={this.props.operatorExclusiveRecordingControl}
        screenSharingParticipantId={this.props.screenSharingParticipantId}
      />
    );
  }
  
  handleParticipantsIcon = () => {
    this.setState({ showWaitingArea: !this.state.showWaitingArea });
  }

  handleAllowEdit = (isEditAllowed, participantId) => {
    const message = {
      data: {
        category: socketMessage.category.SESSION,
        action: socketMessage.subCategories.SESSION.ALLOW_EDIT_ACCESS,
        sessionKey: this.props.sessionKey,
        allowEditAccess: isEditAllowed,
        participantId: participantId,
      },
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  evictAction = (participantId) => {
    // fix added for WAAG-4652 : if participant refreshes then, will have to get changed/latest uniqueId of participant and send evict call to server.
    this.props.admittedParticipants.map((participant) => {
      if (participant.participantId === participantId) {
        audioVideoAction.evictParticipant(
          this.props.sessionKey,
          participant.uniqueId
        );
      }
    });
  };

  execSpeedTest = (participantId) => {
    this.props.admittedParticipants.map((participant) => {
      if (participant.participantId === participantId) {
        const message = {
          data : {
            category: socketMessage.category.SESSION,
            action: socketMessage.subCategories.SESSION.EXEC_SPEED_TEST,
            sessionKey: this.props.sessionKey,
            remoteId: participant.uniqueId,
            name: participant.userName,
          }
        };
        this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      }
    })
  }

  renderWaitingArea = () => {
    return (
      <div className="dashboardWaitingArea">
        <WaitingArea
          participantId={this.props.participantId}
          organiser={this.props.organiser}
          allParticipants={this.state.sortedParticipants}
          presenter={this.props.presenterId}
          uniqueId={this.props.uniqueId}
          sessionLink={this.state.sessionLink}
          sessionKey={this.props.sessionKey}
          language={this.props.language}
          admittedParticipants={this.props.admittedParticipants}
          isReductionLogs={this.props.isReductionLogs}
          isOrganiser={this.props.organiser === this.props.uniqueId}
          makePresenter={this.makePresenter}
          latestUpdatedParticipant={this.props.latestUpdatedParticipant}
          handleParticipantsIcon={this.handleParticipantsIcon}
          admitOrRejectUserInSession={this.admitOrRejectUserInSession}
          updateSortedParticipants={this.updateSortedParticipants}
          setCustomerId={this.props.setCustomerId}
          handleAllowEdit={this.handleAllowEdit}
          evictAction={this.evictAction}
          execSpeedTest={this.execSpeedTest}
        />
      </div>
    );
  };

  sortParticipantToAcronym = () => {
    let participantList = [];
    if (this.props.allParticipants) {
      _.map(this.props.allParticipants, (participantObject) => {
        // sorting done for participants
        // organiser, presenter, self and then others
        if (participantObject.role === USER_ROLES.AGENT) {
          participantList.splice(0, 0, participantObject);
        } else {
          if (this.props.presenter === participantObject.uniqueId) {
            participantList.splice(1, 0, participantObject);
          } else if (participantObject.uniqueId === this.props.uniqueId) {
            if (participantList[1] && participantList[1].uniqueId == this.props.presenter) {
              participantList.splice(2, 0, participantObject);
            } else {
              participantList.splice(1, 0, participantObject);
            }
          } else {
            participantList.push(participantObject);
          }
        }
      });

      this.setState({ sortedParticipants: participantList });
    } else {
      this.setState({ sortedParticipants: this.props.allParticipants });
    }
  };

  getBaseUrl = () => {
    let baseUrl = window.location.origin;
    if (baseUrl) {
      baseUrl = baseUrl + (
        this.props.customerUriIdentifier
          ? "/" + this.props.customerUriIdentifier : ""
      ) + "/join?sessionKey=" + this.props.sessionKey + "&openExternalBrowser=1";
      this.setState({ sessionLink: baseUrl });
    } else {
      baseUrl = window.location.protocol + "//" + window.location.hostname + (
        window.location.port ? ":" + window.location.port : ""
      );
      baseUrl = baseUrl + (this.props.customerUriIdentifier
        ? "/" + this.props.customerUriIdentifier : ""
      ) + "/join?sessionKey=" + this.props.sessionKey;
      this.setState({ sessionLink: baseUrl });
    }
  };

  admitOrRejectUserInSession = (isAdmitted, uniqueId, fromToast) => {
    if (fromToast) {
      toast.dismiss(TOAST_ID.ADMIT + uniqueId);
    }

    // update participants admissionStatus in reducer at agent side
    if (!navigator.onLine) {
      //If Agent is offline ,he must see the network Error
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    headerAction.setParticipantAdmittedOrRejected({
      uniqueId: uniqueId,
      isAdmitted: isAdmitted,
    });

    let message = {
      data: {
        category: socketMessage.category.SESSION,
        action: socketMessage.subCategories.SESSION.JOIN_SESSION_REPLY,
        isAdmitted: isAdmitted,
        uniqueId: uniqueId,
        sessionKey: this.props.sessionKey,
      },
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
  };

  removeActiveFrame = () => {
    const message = {
      data: {
        category: socketMessage.category.PDF,
        action: socketMessage.subCategories.PDF.FREEZE_FRAME,
        canvasId: this.props.activeCanvas.canvasId,
        isFrameLocked: false,
        sessionKey: this.props.sessionKey,
        participantId: null,
      },
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
  };

  showMakePresenter = (presenterName) => {
    this.setState({
      makePresenterPopoverOpen: this.state.makePresenterPopoverOpen,
      presenterName: presenterName,
    });
  };

  makePresenter = (participant) => {
    if (!navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    const { userName, uniqueId } = participant;
    if (this.props.frameLockedParticipantId !== null) 
      this.removeActiveFrame();
    this.showMakePresenter(
      this.state.makePresenterPopoverOpen,
      userName
    );
    let message = {
      data: {
        category: socketMessage.category.NOTIFICATION,
        action: socketMessage.subCategories.NOTIFICATION.MAKE_PRESENTER,
        sessionKey: this.props.sessionKey,
        newPresenterId: uniqueId,
      },
    };
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
    // After replacing the presenter, the reconnection information is deleted because it is not subject to reconnection.
    sessionStorage.removeItem("reconnectionUrl");
    sessionStorage.removeItem("reconnectionUrlForFollower");
  };

  handleScreenShareError = (error) => {
    console.error('ScreenShare Error:', error);
    toastr.error(getMessage("SCREENSHARE_VIEW_ERROR") || "Unable to view screenshare");
  };

  renderScreenShareContainer(screenShareId) {
    console.log('Rendering ScreenShare Container:', {
      screenSharingParticipantId: this.props.screenSharingParticipantId,
      pluginInstalled: this.state.pluginInstalled,
      uniqueId: this.props.uniqueId,
      userRole: this.props.userRole,
      screenShareId: screenShareId
    });
    return (
      <ScreenShareContainer
        screenSharingParticipantId={
          this.props.screenSharingParticipantId
        }
        broadcastDownloadAction={this.props.broadcastDownloadAction}
        admittedParticipants={this.props.admittedParticipants}
        presenterId={this.props.presenterId}
        uniqueId={this.props.uniqueId}
        setComponentInFocus={this.props.setComponentInFocus}
        isLandscape={this.props.isLandscape}
        componentInFocus={this.props.componentInFocus}
        horizontalDisplayFixed={this.state.horizontalDisplayFixed}
        handleFullScreenV2={this.toggleScreenZoomIn}
        putFullScreenV2Target={this.putFullScreenV2Target}
        removeFullScreenV2Target={this.removeFullScreenV2Target}
        isHideBar={this.state.isHideBar}
        toggleHideBar={this.toggleHideBar}
        isZoomOut={this.state.isZoomOut}
        screenShareId={screenShareId}
        screen={this.state.screen}
        isScreenShare={this.state.isScreenShare}
        setValue={this.setValue}
        onError={this.handleScreenShareError} 
        userRole={this.props.userRole} 
        organiser={this.props.organiser} 
        modules={this.props.modules}
      />
    )
  }

  shouldShowZoomIcon = () => {
    return isDesktopView(this.props.orientation)
      && !(this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply))
      && !this.props.showCustomerCoBrowse
  }

  setValue = (name, value) => {
    this.setState({ [name] : value });
  };

  render() {
    const { modulesAndClassNames } = this.props;
    let fullViewPdfContainer = (this.props.activeCanvasData.canvasType === CANVAS_TYPES.PDF || this.props.showCustomerCoBrowse || this.props.showInboundCoBrowse)
      && isMobileView(this.props.orientation)
      && !this.props.isLandscape
      ? " height100"
      : "";

    let mobileContainerHeight = ((this.props.activeCanvasData.canvasType !== CANVAS_TYPES.PDF &&
      !this.props.showCustomerCoBrowse && (this.props.endInboundCoBrowse && this.props.isInboundCobrowseMinimize))
      && isMobileView(this.props.orientation))
      && !this.props.isLandscape
      ? " aligningCenterMobileCanvas"
      : " aligningCenterMobilePdf";

    let whiteboardColWidth = (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO && this.props.showAudioVideoComponent)
      || (this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE && this.props.showCoBrowse) ||
      (this.props.componentInFocus=== COMPONENT_IN_FOCUS.INBOUND_COBROWSE
      && !this.props.endInboundCoBrowse && this.props.showInboundCoBrowse) ? "3 setPositionProperty " : "9";

    let audioVideoColWidth = isTabletPortrait(this.props.orientation) ? "" : (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
      && this.props.showAudioVideoComponent) ? "auto" : "3";

    let CoBrowseColWidth = this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE
      && this.props.showCoBrowse
      ? "9"
      : "3";

    let inboundCoBrowseColWidth = this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE
      && !this.props.endInboundCoBrowse
      ? "auto" : "3";

    const isFocusCanvas = this.props.componentInFocus == COMPONENT_IN_FOCUS.CANVAS;
    const isFocusCoBrowse = this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE;
    const isFocusInboundCoBrowse = this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE;
    const showSnapshot = this.props.showSnapshot || (this.props.snapshoteeId && this.props.snapshotPermissionReply);
    const unAvailableCanvas = Object.keys(this.state.canvases).length > 0 && this.props.modules.indexOf(Modules.CANVAS) == -1;
    const availableCanvas = this.props.modules.indexOf(Modules.CANVAS) !== -1;
    const sideCanvas = (!this.state.isZoomOut && this.props.screenSharingParticipantId !== null) || this.props.showCustomerCoBrowse;
    const hasAgentRole = this.props.admittedParticipants?.some(participant => participant.role === "AGENT");
    const hasUserRole = this.props.admittedParticipants?.some(participant => participant.role === "USER");

    return (
      <Container className="dashboard" id="dashboard">
        <Spinner showSpinner={this.state.spinnerVisibility}/>
        <Row className={"positionRelative height100 w-100 noMargin" + mobileContainerHeight}>
          <Row
            className="width100 noMargin mobileFlexContainer"
          >
            {/** Whiteboard with DashboardMenu */}
            <Col
              lg={
                !this.shouldShiftWhiteboardToLeft() && isDesktopView(this.props.orientation)
                  ? { offset: "1", size: "10" }
                  : isFocusCanvas
                    ? "auto"
                    : "3"
              }
              className={isFocusCanvas ? "order-2 noPadding dashboardMain" : "dashboardSide order-3"}
            >
              {isDesktopView(this.props.orientation) &&
                <Col className={!isFocusCanvas && (this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE 
                  || (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO &&
                  this.props.showAudioVideoComponent)) || this.state.isScreenShare ? "dashboardMenuContainer" : "displayNone"}>
                  {this.renderDashboardMenu()}
                </Col>
              }
              <Col
                className={this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO || 
                  this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE
                  ? "dashboardScrollContainer"
                  : "noPadding h-100"
                }
              >
                {this.state.showWaitingArea &&
                  (this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE ||
                  (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO && this.props.showAudioVideoComponent)) &&
                  isDesktopView(this.props.orientation) &&
                  this.renderWaitingArea()
                }
                {/** Audio Video Container isMine */}
                {
                  this.props.showAudioVideoComponent &&
                  this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO &&
                  ((this.props.sessionType !== SESSION_SUBTYPES.SUPPORT_CENTER || 
                    ((this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO ||
                    this.props.webRtcPermissionRequest === mediaType.AUDIO)))) &&
                  this.props.sortedParticipants.length > 1 &&
                  isDesktopView(this.props.orientation) &&
                  <div
                    className={"container px-0 item-3"}
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(true, false)}
                  </div>
                }
                {/** Audio Video Container is focused inbound cobrowse - agent*/}
                {this.props.showAudioVideoComponent &&
                  (this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE) &&
                  isDesktopView(this.props.orientation) && hasAgentRole &&
                  <div
                    className={"container px-0 item-4"}
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(true, false)}
                  </div>
                }
                {/** Audio Video Container is focused inbound cobrowse - user */}
                {this.props.showAudioVideoComponent &&
                  (this.props.componentInFocus === COMPONENT_IN_FOCUS.INBOUND_COBROWSE) &&
                  isDesktopView(this.props.orientation) && hasUserRole &&
                  <div
                    className={"container px-0 item-3"} /*  */
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(false, false)}
                  </div>
                }
                {/* Screen Share Side Container */}
                {
                  this.shouldShiftWhiteboardToLeft() &&
                  this.props.screenSharingParticipantId !== null &&
                  this.state.pluginInstalled && isDesktopView(this.props.orientation) &&
                  this.state.isZoomOut && this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS &&
                  <Col
                    id="screenshareSideContainer1"
                    className={
                      this.state.isZoomOut
                        ? "displayInline noPadding flex0 item-2"
                        : "displayNone noPadding"
                    }
                  >
                    {this.renderScreenShareContainer("screenshareSide1")}
                  </Col>
                }
                { /** Whiteboard Container*/}
                {
                  /* Hide this for future purposes only */
                  // ((isDesktopView(this.props.orientation) && !sideCanvas) || (isMobileView(this.props.orientation) && isFocusCanvas)) &&
                  // (this.props.modules.indexOf(Modules.CANVAS) !== -1 ||
                  //   this.props.modules.indexOf(Modules.CANVAS) == -1 && showSnapshot ||
                  //   unAvailableCanvas) &&
                  // <Col
                  //   className={!this.shouldShiftWhiteboardToLeft()
                  //     ? "whiteboardParentContainer " + modulesAndClassNames.CANVAS + fullViewPdfContainer
                  //     : "whiteboardParentContainer " + fullViewPdfContainer
                  //   }
                  //   id="WhiteboardParentContainer"
                  // >
                  //   <div
                  //     id="whiteboard"
                  //     className={(whiteboardColWidth === "3 setPositionProperty " ? "cardBody w-100" : "canvasActive") + fullViewPdfContainer}>
                  //     {this.renderWhiteboardContainer()}
                  //   </div>
                  //   {/* Canvas list */
                  //     ((isFocusCoBrowse || isMobileView(this.props.orientation) && !showSnapshot || isDesktopView(this.props.orientation)) && isFocusCanvas && (unAvailableCanvas || availableCanvas)) &&
                  //     <Col
                  //       xs="auto"
                  //       className="canvasListContainer"
                  //     >
                  //       {this.renderCanvasList(true)}
                  //     </Col>
                  //   }
                  // </Col>
                }
              </Col>
            </Col>

            {/** AudioVideo  */}
            {this.shouldShiftWhiteboardToLeft() && 
              this.props.showAudioVideoComponent &&
              <Col
                lg={audioVideoColWidth}
                className={this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
                  ? "order-2 noPadding dashboardMain" : "dashboardSide order-3"}
              >
                <Col
                  className={isDesktopView(this.props.orientation) &&
                    isFocusCanvas
                    ? "dashboardMenuContainer"
                    : "displayNone"
                  }
                >
                  {this.renderDashboardMenu()}
                </Col>
                <Col
                  className={isDesktopView(this.props.orientation) &&
                    isFocusCanvas
                    ? "dashboardScrollContainer containerWithVideo"
                    : "noPadding"
                  }
                >
                  {isDesktopView(this.props.orientation) &&
                    this.state.showWaitingArea &&
                    this.shouldShiftWhiteboardToLeft() &&
                    isFocusCanvas &&
                    this.renderWaitingArea()
                  }
                  { /** Audio Video Container isMine */}
                  {
                    this.shouldShiftWhiteboardToLeft() &&
                    this.props.showAudioVideoComponent &&
                    this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO &&
                    this.props.sortedParticipants.length > 1 && (
                      <div
                        className={"px-0 item-4"}
                        id="AudioVideoContainer2"
                      >
                        {this.renderAudioVideoContainer(true, false)}
                      </div>
                    )
                  }
                  { /** Audio Video Container !isMine */}
                  {this.shouldShiftWhiteboardToLeft() &&
                    this.props.showAudioVideoComponent &&
                    !(isMobileView(this.props.orientation) && this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO) && 
                      <>
                        <div
                          className={this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
                            ? "px-0"
                            : "px-0 setPositionProperty item-3"
                          }
                          id="AudioVideoContainer"
                        >
                          {this.renderAudioVideoContainer(false, (isDesktopView(this.props.orientation) || isMobileView(this.props.orientation) && this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO))}
                        </div>
                      </>
                  }
                  { /** Whiteboard Side Container*/}
                  {
                    /* Hide this for future purposes only */
                    // isDesktopView(this.props.orientation) && sideCanvas && (unAvailableCanvas || availableCanvas) && 
                    // <Col
                    //   className={"whiteboardParentContainer " + modulesAndClassNames.CANVAS + fullViewPdfContainer}
                    //   id="WhiteboardParentContainer"
                    // >
                    //   <div
                    //     id="whiteboard"
                    //     className={"cardBody w-100" + fullViewPdfContainer}>
                    //     {this.renderWhiteboardContainer()}
                    //   </div>
                    // </Col>
                  }
                </Col>
              </Col>
            }

            {
              isMobileView(this.props.orientation) && this.renderMobileBottomArea()
            }
            {/**
							 *  COBROWSE Container
							 */}
            {isDesktopView(this.props.orientation) && this.shouldShiftWhiteboardToLeft() &&
              this.props.showCoBrowse &&
              <Col
                lg={CoBrowseColWidth}
                className={this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE || isMobileView(this.props.orientation)
                  ? "mb-lg-2 px-2 px-md-0 "// left padding is already added for canvas
                  : "mb-2 container px-2 pt-2 setPositionProperty " + modulesAndClassNames.COBROWSE
                }
                // lg={audioVideoColWidth}
                // className={this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
                //   ? "mb-2 px-0 " // left padding is already added for canvas
                //   : (isMobileView(this.props.orientation) && this.props.componentInFocus !== COMPONENT_IN_FOCUS.AUDIO_VIDEO)
                //     ? "px-0 container setPositionProperty " + modulesAndClassNames.AUDIO_VIDEO
                //     : "mb-2 container px-2 setPositionProperty " + modulesAndClassNames.AUDIO_VIDEO
                // }
                id="CoBrowseContainer"
              >
                {/* // show self audio / video related icon bar */}
                {this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE
                  && this.renderSelfAudioVideoIconBar()}
              </Col>
            }

            {/* Inbound cobrowse Container */}
            {!this.props.endInboundCoBrowse &&
              <Col
                id={isFocusInboundCoBrowse ? "InboundCoBrowseContainer" : undefined}
                lg={inboundCoBrowseColWidth}
                className={
                  isFocusInboundCoBrowse && (!this.props.endInboundCoBrowse && !this.props.isInboundCobrowseMinimize)
                    ? "order-2 noPadding dashboardMain" : "dashboardSide order-2"}
              >
                {isDesktopView(this.props.orientation) &&
                  <Col className={isFocusInboundCoBrowse ? "displayNone" : "dashboardMenuContainer"}>
                    {this.renderDashboardMenu()}
                  </Col>
                }
                <Col
                  className={!isFocusInboundCoBrowse
                    ? "dashboardScrollContainer"
                    : "noPadding h-100"
                  }
                >
                  {this.state.showWaitingArea &&
                    this.props.componentInFocus !== COMPONENT_IN_FOCUS.INBOUND_COBROWSE &&
                    isDesktopView(this.props.orientation) &&
                    this.renderWaitingArea()
                  }
                  {/* Inbound cobrowse container main and side */}
                  <Col
                    className={
                      isFocusInboundCoBrowse && isDesktopView(this.props.orientation) 
                        ? "displayInboundMain noPadding"
                        : isFocusInboundCoBrowse && isMobileView(this.props.orientation) 
                          ? "displayInboundMain noPadding" 
                          : !isFocusInboundCoBrowse && isMobileView(this.props.orientation) 
                            ? "displayNone" 
                            : "displayInline noPadding item-1" 
                    }
                  >
                    {this.renderInboundCoBrowseContainer()}
                  </Col>
                  {/** Audio Video Container is focused screenshare - agent*/}
                  {this.props.showAudioVideoComponent &&
                  (!this.props.endInboundCoBrowse && isFocusCanvas) &&
                  isDesktopView(this.props.orientation) && hasAgentRole &&
                  <div
                    className={"container px-0 item-4"}
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(true, false)}
                  </div>
                  }
                  {/** Audio Video Container is focused screenshare - user */}
                  {this.props.showAudioVideoComponent &&
                  (!this.props.endInboundCoBrowse && isFocusCanvas) &&
                  isDesktopView(this.props.orientation) && hasUserRole &&
                  <div
                    className={"container px-0 item-3"}
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(false, false)}
                  </div>
                  }
                  {/** Audio Video Container is focused - agent */}
                  {this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO && this.props.showAudioVideoComponent &&
                  ((this.props.isInboundCobrowseMinimize && !this.props.endInboundCoBrowse) && !isFocusCanvas) &&
                  isDesktopView(this.props.orientation) && hasAgentRole &&
                  <div
                    className={"container px-0 item-4"}
                    id="AudioVideoContainer2"
                  >
                    {this.renderAudioVideoContainer(true, false)}
                  </div>
                  }
                  {/* Screenshare side container */}
                  {!isFocusInboundCoBrowse && 
                    (this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO && this.props.showAudioVideoComponent) &&
                    (this.props.screenSharingParticipantId !== null && this.state.pluginInstalled) &&
                    <Col
                      className="displayInline noPadding item-2"                    
                    >
                      {this.renderScreenShareContainer("screenshareSide2")}
                    </Col>
                  }                  
                </Col>
              </Col>
            }

          </Row>

          {/* Screen Share Container */}
          {
            this.shouldShiftWhiteboardToLeft() &&
            this.props.screenSharingParticipantId !== null &&
            this.state.pluginInstalled &&
            <Col
              id="screenshareContainer"
              className={
                !this.state.isZoomOut
                  ? "displayInline screenShare"
                  : "displayNone" + " noPadding"
              }
            >
              {this.renderScreenShareContainer("screenshare")}
            </Col>
          }

          {isDesktopView(this.props.orientation) &&
            (this.props.showCustomerCoBrowse || this.props.showTargetSiteSelectionModal) &&
            <div
              id="customerCoBrowseWrapper"
              className={this.props.showCustomerCoBrowse && this.props.endCustomerCBSession ? "col-lg-9 customerCoBrowseContainerOnReload" : this.shouldShiftWhiteboardToLeft() ?
                "customerCoBrowseContainerParent col-lg-9 px-0" :
                "customerCoBrowseContainerParent col-lg-9 offset-lg-1 px-0"}
            >
              <div id="customerCoBrowseContainerParent">
                {/* 2022-11-29 現行or新アーキテクチャのコブラウズ描画 */}
                {this.renderCustomerCoBrowseContainer()}
              </div>
            </div>
          }

          {isMobileView(this.props.orientation) &&
            <Row className={(this.props.componentInFocus === COMPONENT_IN_FOCUS.AUDIO_VIDEO
              ? "width100 noMargin"
              : "width100 noMargin") + fullViewPdfContainer
            }>
              {/**
               *  COBROWSE Container
              */}
              {this.shouldShiftWhiteboardToLeft() &&
                this.props.showCoBrowse &&
                <Col
                  lg={CoBrowseColWidth}
                  className={this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE || isMobileView(this.props.orientation)
                    ? "mb-lg-2 px-2 px-md-0 "// left padding is already added for canvas
                    : "mb-2 container px-2 pt-2 setPositionProperty " + modulesAndClassNames.COBROWSE
                  }
                  id="CoBrowseContainer"
                >
                  {this.renderCoBrowseContainer()}
                  {/* // show self audio / video related icon bar */}
                  {this.props.componentInFocus === COMPONENT_IN_FOCUS.COBROWSE
                    && this.renderSelfAudioVideoIconBar()}
                </Col>
              }
              {(this.props.showCustomerCoBrowse || this.props.showTargetSiteSelectionModal) &&
                <div
                  id="customerCoBrowseWrapper"
                  className={this.props.showCustomerCoBrowse && this.props.endCustomerCBSession 
                    ? "customerCoBrowseContainerOnReload"
                    : "customerCoBrowseContainerParent px-0"
                  }
                >
                  <div
                    id="customerCoBrowseContainerParent"
                    style={{ position: "relative" }}
                  >
                    {/* 2022-11-29 現行or新アーキテクチャのコブラウズ描画 */}
                    {this.renderCustomerCoBrowseContainer()}
                  </div>
                </div>
              }
            </Row>
          }
          
          <Row className={"rightCornerPositionContainer"}>
            <Row>
              {
                // displaying meeting time
                <MeetingTime
                  sessionStartTime={this.props.sessionStartTime}
                  sessionStatus={this.props.sessionStatus}
                />
              }
              { 
                // total bit rate
                window._env_.REACT_APP_SHOW_BITRATE == "true" &&
                !isIE &&
                <TotalBitRate
                  className="rightCornerPosition"
                  uniqueId={this.props.uniqueId}
                  parentContainer={document}
                  sentLabel={getMessage("TOTAL_SENT")}
                  recvLabel={getMessage("TOTAL_RECV")}
                />
              }
            </Row>
          </Row>
        </Row>
        {/**
           *  FullScreenV2
          */}
        {isAndroidPhone()
          && this.renderFullScreenContainer()
        }
        {
          // ContractInfoModal
          <ContractInfoModal />
        }
      </Container>
    );
  }

  componentWillUnmount() {
    this.virtualBackgroundFilter && this.virtualBackgroundFilter.destroy();
    this.stopTracks(this.currentStream);
    this.stopAudioTracks(this.currentAudioStream);
    console.log(`this.currentStream = ${this.currentStream} ,this.currentAudioStream = ${this.currentAudioStream}`);
    if(this.needRemoveFullScreenChangeHandler) {
      screenFull.off('change', this.fullScreenChangeHandler );
    }
    window.removeEventListener("resize",this.setScreenShareTopMargin());
    if(isIE){
      window.removeEventListener('resize', this.setTimeOutAnnotationBarToBottom);
    }
  }
}
export default withOrientationChange(Dashboard);
